import angular from 'angular'

import { includes, camelCase } from 'lodash-es'

import genExposeName from './gen-expose-name'

angular
  .module('ggs.utils')
  .factory('idPrefix', idPrefixProvider)
  .factory('addIdPrefix', addIdPrefixProvider)
  .factory('hasIdPrefix', hasIdPrefixProvider)

function idPrefixProvider(env) {
  const camelKey = camelCase(env.props.galleryKey)
  const idPrefix = genExposeName(`ggsIdPrefix_${camelKey}_:count:`)

  window[idPrefix] = true
  window.ggsIdPrefix_debug_last = idPrefix

  return idPrefix
}

function addIdPrefixProvider(idPrefix) {
  return function addIdPrefix(id) {
    return idPrefix + '_' + id
  }
}

function hasIdPrefixProvider(idPrefix) {
  return function hasIdPrefix(id) {
    return includes(id, idPrefix)
  }
}
